// Hook: estado da sessão iSolve do usuário logado (SPEC 4c §2.2)
// Leitura: no mount, ao refocar a aba/janela, e via refetch() manual.
// Sem polling em intervalo - gatilho manual (R1).

import { useState, useEffect, useCallback } from 'react';
import { isolveApi, type SessaoISolveStatus } from '../services/api';

export function useSessaoISolve() {
  const [sessao, setSessao] = useState<SessaoISolveStatus | null>(null);
  const [carregando, setCarregando] = useState(false);

  const refetch = useCallback(async () => {
    setCarregando(true);
    try {
      const data = await isolveApi.getSessaoMinha();
      setSessao(data);
    } catch {
      // Erro de rede/auth não quebra o app - semáforo fica no último estado
    } finally {
      setCarregando(false);
    }
  }, []);

  // Leitura inicial
  useEffect(() => { refetch(); }, [refetch]);

  // Leitura ao refocar aba/janela
  useEffect(() => {
    const handler = () => refetch();
    window.addEventListener('focus', handler);
    return () => window.removeEventListener('focus', handler);
  }, [refetch]);

  return { sessao, carregando, refetch };
}
